export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_POSSIBLE_DESTINATIONS = 'SET_POSSIBLE_DESTINATIONS'
export const SET_POSSIBLE_DEPARTURES = 'SET_POSSIBLE_DEPARTURES'
export const SET_POSSIBLE_TRANSPORTS = 'SET_POSSIBLE_TRANSPORTS'
export const SET_POPULAR_DESTINATIONS = 'SET_POPULAR_DESTINATIONS'

export const setLanguage = (lang) => ({
    type: SET_LANGUAGE,
    payload: lang
})

export const setPopularDestinations = (popular) => ({
    type: SET_POPULAR_DESTINATIONS,
    payload: popular
})

export const setPossibleDestinations = (destinations) => ({
    type: SET_POSSIBLE_DESTINATIONS,
    payload: destinations
})

export const setPossibleDepartures = (departures) => ({
    type: SET_POSSIBLE_DEPARTURES,
    payload: departures
})

export const setPossibleTransports = (transports) => ({
    type: SET_POSSIBLE_TRANSPORTS,
    payload: transports
})
